var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 5.73362C13.733 5.40028 13.4663 5.00028 13.133 5.00028L9.33301 4.46695L7.59967 1.00028C7.53301 0.866951 7.46634 0.800284 7.33301 0.733618C6.99967 0.533618 6.59967 0.666951 6.39967 1.00028L4.73301 4.46695L0.933008 5.00028C0.733008 5.00028 0.599674 5.06695 0.533008 5.20028C0.266341 5.46695 0.266341 5.86695 0.533008 6.13362L3.26634 8.80028L2.59967 12.6003C2.59967 12.7336 2.59967 12.867 2.66634 13.0003C2.86634 13.3336 3.26634 13.467 3.59967 13.267L6.99967 11.467L10.3997 13.267C10.4663 13.3336 10.5997 13.3336 10.733 13.3336C10.7997 13.3336 10.7997 13.3336 10.8663 13.3336C11.1997 13.267 11.4663 12.9336 11.3997 12.5336L10.733 8.73362L13.4663 6.06695C13.5997 6.00028 13.6663 5.86695 13.6663 5.73362Z",
    fill: "#CBA640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b6fad680bb3eeaeff40273de2b1599a9.svg";
export { ForwardRef as ReactComponent };